module.exports = __webpack_public_path__ + "img/napco-logo.8462b346.png";